import React from 'react';
import classNames from 'classnames';
import { get } from 'rc-util/lib/Dom/css';
import Tooltip from '../../../tooltip';
const ShortcutList = (props) => {
    const { list, curShortcut, disabledShortcutOptions, postbackDates } = props;
    const uuid = React.useMemo(() => Math.ceil(Math.random() * 10000), []);
    // 点击快捷选项
    const handleClickShortcut = (index) => {
        const shortcut = list[index];
        postbackDates(shortcut);
    };
    const judgeOverflowing = (target) => {
        let overflowing = false;
        if (target) {
            const range = document.createRange();
            range.setStart(target, 0);
            range.setEnd(target, target.childNodes.length);
            const rangeWidth = Math.floor(range.getBoundingClientRect().width);
            const padding = (get(target, 'paddingLeft') || 0) + (get(target, 'paddingRight') || 0);
            if (rangeWidth + padding > target.offsetWidth || target.scrollWidth > target.offsetWidth) {
                overflowing = true;
            }
        }
        return overflowing;
    };
    return (<ul className="date-list">
      {list.map((opt, index) => {
            const disabledOpt = disabledShortcutOptions === null || disabledShortcutOptions === void 0 ? void 0 : disabledShortcutOptions.find(item => item.value === opt.value);
            const showPopover = disabledOpt &&
                (typeof disabledOpt.popoverContent === 'number' ||
                    typeof disabledOpt.popoverContent === 'string' ||
                    React.isValidElement(disabledOpt.popoverContent));
            const isOverflowing = judgeOverflowing(document.getElementById(`content-${index}-${uuid}`));
            return (<Tooltip title={disabledOpt === null || disabledOpt === void 0 ? void 0 : disabledOpt.popoverContent} trigger={showPopover ? ['hover'] : ['']} key={opt.value} zIndex={1050} mouseEnterDelay={0} mouseLeaveDelay={0} getPopupContainer={triggerNdoe => triggerNdoe.parentElement || document.body}>
            <li id={`content-${index}-${uuid}`} className={classNames('', {
                    active: curShortcut.value === opt.value,
                    disabled: disabledOpt,
                })} key={opt.value} onClick={() => !disabledOpt && handleClickShortcut(index)} title={isOverflowing ? opt.label : ''}>
              {opt.label}
            </li>
          </Tooltip>);
        })}
    </ul>);
};
export default ShortcutList;
